import Vue from 'vue'
import App from './App.vue'

import VueRouter from 'vue-router'
import vuexI18n from 'vuex-i18n'

import { routes } from './routes'
import { store } from './store'
import { translationsEn } from './lang/en'
import { translationsNl } from './lang/nl'
import VueAnalytics from 'vue-analytics'

import VueCarousel from 'vue-carousel'
Vue.use(VueCarousel)

// import Vue2TouchEvents from 'vue2-touch-events'
// Vue.use(Vue2TouchEvents)

import './assets/css/style.css'
import './assets/css/skins/colors/orange.css'
import './assets/css/layout/wide.css'

Vue.use(VueRouter)
Vue.use(vuexI18n.plugin, store,
    {
      moduleName: 'i18n',
      onTranslationNotFound (locale, key) {
        console.warn(`i18n::Key '${key}' not found for locale '${locale}'`)
        return `***${key}***`
      },
    },
)

window.getBrowserLanguage = () => {
  let userLanguage = navigator.language
  if (userLanguage !== undefined) {
    let language = userLanguage.substring(0, 2)
    if (!(Vue.i18n.localeExists(language))) {
      return 'en'
    }
    return language
  } else {
    return 'en'
  }
}

Vue.i18n.add('en', translationsEn)
Vue.i18n.add('nl', translationsNl)

let browserLanguage = window.getBrowserLanguage()
// let browserLanguage = 'nl'
Vue.i18n.set(browserLanguage)
store.state.currentLanguage = browserLanguage

export const router = new VueRouter({
  mode: 'history',
  routes
})

Vue.config.productionTip = false

router.beforeEach((to, from, next) => {
  // let language = to.params.lang
  //
  // if (!language) {
  //   language = window.getBrowserLanguage()
  // }
  //
  // console.log(language)
  //
  // Vue.i18n.set(language)
  // // Vue.config.lang = to.params.lang
  next()
})

Vue.use(VueAnalytics, {
  id: 'UA-96460539-1',
  router,
  debug: {
    sendHitTask: process.env.NODE_ENV === 'production'
  }
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
